import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import styles from './dams-vis.module.scss';
import ReactTooltip from 'react-tooltip';

const legendItems = [
  {
    label: 'Seqwater',
    color: '#641D00', // brown
    textColor: '#641D00',
  },
  {
    label: 'Sunwater',
    color: '#AD3402', // red
    textColor: '#641D00',
  },
  {
    label: 'Other government',
    color: '#EC9872', // orange
    textColor: '#A14621',
  },
  {
    label: 'Council owned',
    color: '#FBEBC3', // yellow
    textColor: '#DC9C3A',
  },
  {
    label: 'Privately owned',
    color: '#E3E3E3', // grey
    textColor: '#87878A',
  },
];

// Bar component
const DamsVisBar = ({ type, total, breakdown }) => {
  return (
    <div className={styles.bar}>
      {Object.entries(breakdown).map(([status, value], i) => {
        const percent = (100 / total) * value;
        return (
          <div
            key={i}
            className={styles.droughtBarSection}
            style={{
              backgroundColor: legendItems.find((x) => x.label === status)
                .color,
              width: `${percent}%`,
              minWidth: '22px',
              height: '100%',
            }}
            data-tip={`${status}: ${value} ${
              type === 'dams' ? 'dams' : 'ML'
            }`}
          ></div>
        );
      })}
      <ReactTooltip multiline={true} border={true} />
    </div>
  );
};

const PercentBar = ({ type, label, data }) => {
  const { total, breakdown } = data;

  return (
    <div>
      <div>
        <span className={styles.barHeaderName}>{label}</span>
        <div className={styles.percentWrapper}>
          {Object.entries(breakdown).map(([status, value], i) => {
            const percent = (100 / total) * value;
            return (
              <span
                key={i}
                className={styles.percentSpan}
                style={{
                  color: legendItems.find((x) => x.label === status).textColor,
                  width: `${percent}%`,
                  minWidth: '22px'
                }}
              >{`${percent.toFixed(0)}%`}</span>
            );
          })}
        </div>
      </div>
      <DamsVisBar type={type} total={total} breakdown={breakdown} />
    </div>
  );
};

const Legend = () => {
  return (
    <div className={styles.legend}>
      {legendItems.map((item, i) => {
        return (
          <div key={i} className={`${styles.legendItem}`}>
            <div
              className={styles.legendSquare}
              style={{
                backgroundColor: item.color,
              }}
            />
            <span
              className={styles.legendText}
              style={{ color: item.textColor }}
            >
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

const DamsVis = ({ dams }) => {
  const damsOwnedData = {
    total: dams.length,
    breakdown: {},
  };
  const totalCapacityData = {
    total: dams.filter(x => typeof x.capacity === "number").reduce((a, b) => a + b.capacity, 0),
    breakdown: {},
  };
  legendItems.forEach((x) => {
    damsOwnedData.breakdown[x.label] = dams.filter(
      (d) => d.ownerType === x.label
    ).length;
    totalCapacityData.breakdown[x.label] = dams
      .filter((d) => d.ownerType === x.label && typeof d.capacity === "number")
      .reduce((a, b) => a + b.capacity, 0);
  });

  return (
    <div>
      <Legend />
      <div className={styles.barArea}>
        <div className={styles.barColumn}>
          <PercentBar type="dams" label="Dams owned" data={damsOwnedData} />
        </div>
        <div className={styles.barColumn}>
          <PercentBar type="capacity" label="Total capacity" data={totalCapacityData} />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  dams: selectors.getDams(state),
});

DamsVis.propTypes = {
  dams: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps, mapDispatchToProps)(DamsVis);



// WEBPACK FOOTER //
// ./src/components/dams-vis/dams-vis.js